import React, { useState, useEffect } from 'react';
import './FloatingWhats.css';
// basicamente criar um novo estilo, acredito que o importante da funcionalidade aqui dá pra manter
import whatsIcon from '../../assets/whatsapp-icon.png';

const FloatingWhats = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const sobreSection = document.getElementById('sobre');
            const sobreRect = sobreSection.getBoundingClientRect();

            const isSobreVisible = sobreRect.top < window.innerHeight && sobreRect.bottom >= 0;
            const isBelowSobre = sobreRect.top < window.innerHeight && sobreRect.bottom < 0;

            setIsVisible(isSobreVisible || isBelowSobre);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const openWhatsApp = () => {
        const whatsappLink = 'https://api.whatsapp.com/send?phone=5511943421608&text=Oi,%20vi%20o%20seu%20site%20pelo%20Google%20e%20tenho%20interesse%20em%20come%C3%A7ar%20o%20processo%20terap%C3%AAutico.%20Como%20podemos%20dar%20o%20primeiro%20passo%3F';
        window.open(whatsappLink, '_blank');
    };

    const buttonClass = isVisible ? 'whatsapp-button' : 'whatsapp-button whatsapp-button-fade';

    return (
        <div className={buttonClass} onClick={openWhatsApp}>
            <img src={whatsIcon} alt="WhatsApp" />
        </div>
    );
};

export default FloatingWhats;
